<template>
  <div class="rt-button-group"><slot /></div>
</template>

<script>
export default {
  name: 'RtButtonGroup'
};
</script>
<style lang="less">
.rt-button-group {
  // height: 50px;
  display: flex;
  align-items: center;
  .el-button {
    padding: 4px;
    border-color: #ced5ef;
    .rt-icon {
      margin: 0;
    }
    span.rt-button-text {
      color: #ced5ef;
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtButtonGroup.vue?6684bda3